<template>
  <Card class="message">
    <slot></slot>
  </Card>
</template>

<script>
import Card from "./Card";
export default {
  props: {},
  components: { Card },
};
</script>
<style lang="scss" scoped>
.message {
  background: #ffc107;
  color: #fff;
  text-align: center;
}
</style>
